import { render, staticRenderFns } from "./ContenedorRsPasesHoteles.vue?vue&type=template&id=2ed866a0&"
import script from "./ContenedorRsPasesHoteles.vue?vue&type=script&lang=js&"
export * from "./ContenedorRsPasesHoteles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/JOSE DUARTE/Desktop/AllSeasons/WebActual/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VAvatar,VCard,VCardText,VChip,VContainer,VFlex,VIcon,VLayout,VProgressLinear,VSubheader,VTab,VTabItem,VTabs})


/* vuetify-loader */
import installDirectives from "!C:/Users/JOSE DUARTE/Desktop/AllSeasons/WebActual/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Resize } from 'vuetify/lib/directives'
installDirectives(component, {Resize})
